var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.334 22.8359L26.4189 22.8398C26.8391 22.8826 27.167 23.2375 27.167 23.6689C27.167 24.1004 26.8391 24.4553 26.4189 24.498L26.334 24.502H9.66699C9.20675 24.502 8.83398 24.1292 8.83398 23.6689C8.83398 23.2087 9.20675 22.8359 9.66699 22.8359H26.334Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 10.3359L17.1709 10.251C17.2136 9.8308 17.5686 9.50293 18 9.50293C18.4314 9.50293 18.7864 9.8308 18.8291 10.251L18.833 10.3359L18.833 12.0029C18.833 12.4632 18.4602 12.8359 18 12.8359C17.5398 12.8359 17.167 12.4632 17.167 12.0029L17.167 10.3359Z",
    fill: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4505 12.0117C19.5004 12.0681 20.5349 12.321 21.5081 12.7607C22.6202 13.2633 23.6306 14.0002 24.4818 14.9287C25.3329 15.8572 26.0084 16.9597 26.4691 18.1729C26.8321 19.1288 27.0563 20.1392 27.1351 21.167C27.1702 21.6259 26.7936 22 26.3333 22H18.0003V20.333H25.348C25.2688 19.9031 25.1591 19.4806 25.0199 19.0693L24.9105 18.7646C24.5711 17.8708 24.0961 17.055 23.5111 16.3506L23.2533 16.0547C22.6374 15.3829 21.9266 14.8393 21.1556 14.4414L20.8216 14.2803C20.0344 13.9246 19.2022 13.7219 18.3607 13.6768L18.0003 13.667C17.1569 13.667 16.3172 13.8247 15.5179 14.1367L15.1781 14.2803C14.3905 14.6362 13.6582 15.1404 13.016 15.7754L12.7464 16.0547C12.1302 16.7269 11.6203 17.5155 11.2425 18.3867L11.0892 18.7646C10.897 19.2708 10.7505 19.7962 10.6517 20.333H18.0003V22H9.66634L9.58138 21.9961C9.16094 21.9534 8.83261 21.5972 8.86556 21.167C8.93447 20.2677 9.11454 19.382 9.40169 18.5342L9.53158 18.1729C9.93466 17.1114 10.5017 16.1347 11.2074 15.2852L11.5179 14.9287C12.2626 14.1163 13.1295 13.4513 14.0794 12.9609L14.4925 12.7607C15.6045 12.2584 16.7967 12 18.0003 12L18.4505 12.0117Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhiteIcon);
export default __webpack_public_path__ + "static/media/menuWhiteIcon.c98ce7ea86d6909343bec77cf6244e38.svg";
export { ForwardRef as ReactComponent };